go-overlay.go-search-bar-overlay {
  .close-btn-wrapper {
    display: none;
    position: fixed;
    top: 1rem;
    right: 1rem;
  }
  &.active {
    .close-btn-wrapper {
      display: block;
    }
  }
}
